module.exports = __webpack_public_path__ + "static/f4-86418a846203782bfa5981f817000b01.png";